import { useCurrentEditor, useEditorState } from "@tiptap/react";
import type { FC } from "react";

import { EditorButton, type EditorButtonProps } from "./editor-button";

export const EditorButtonStrike: FC<EditorButtonProps> = (props) => {
  const { editor } = useCurrentEditor();
  const editorState = useEditorState({
    editor,
    selector: (ctx) => ({
      canToggleStrike: ctx.editor?.can().chain().toggleStrike().run() ?? false,
      isStrike: ctx.editor?.isActive("strike") || false,
    }),
  });

  if (!editor || !editorState) {
    return null;
  }

  return (
    <EditorButton
      {...props}
      onClick={() => editor.chain().focus().toggleStrike().run()}
      disabled={!editorState.canToggleStrike}
      active={editorState.isStrike}
      icon="format_strikethrough"
      tooltip="Strikethrough"
    />
  );
};
